import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SAVE_DRAFT = 'DRAFT :: SAVE';

export type TSaveDraftAction = IReduxAction<typeof SAVE_DRAFT>;

export const saveDraft = actionGenerator<typeof SAVE_DRAFT>(SAVE_DRAFT);
